export default __webpack_public_path__ + "static/media/Margot_Zaher_AHV_In_Moms_We_Trust.c0b23427.jpg";